import { combineReducers } from 'redux';
import preloader from 'reducers/preloader';
import user from 'reducers/user';
import requests from 'reducers/requests';
import request from 'reducers/request';
import wizard from 'reducers/wizard';
import model from 'reducers/model';
import devices from 'reducers/devices';
import labs from 'reducers/labs';
import uploads from 'reducers/uploads';
import agreement from 'reducers/agreement';
import notifier from 'reducers/notifier';
import tests from 'reducers/tests';
import system from 'reducers/system';
import comments from 'reducers/comments';
import badges from 'reducers/badges';
import app from 'reducers/app';
import countries from 'reducers/countries';

const rootReducer = combineReducers({
  agreement,
  app,
  badges,
  comments,
  countries,
  devices,
  labs,
  model,
  notifier,
  preloader,
  request,
  requests,
  system,
  tests,
  uploads,
  user,
  wizard
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js